import { useId } from "react";

type BrandModePreviewProps = {
  className?: string;
  src: string | null;
  title: string;
};

export const BrandModePreview = (props: BrandModePreviewProps) => {
  const id = useId();
  const innerMaskId = `${id}-inner`;
  const batteryClipId = `${id}-battery`;

  return (
    <svg
      className={props.className}
      width="348"
      height="230"
      viewBox="0 0 348 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M0 12C0 5.37259 5.37258 0 12 0H336C342.627 0 348 5.37258 348 12V218C348 224.627 342.627 230 336 230H12C5.37259 230 0 224.627 0 218V12Z"
        fill="#F5F5F5"
      />
      <mask id={innerMaskId} fill="white">
        <path d="M24 36C24 29.3726 29.3726 24 36 24H312C318.627 24 324 29.3726 324 36V230H24V36Z" />
      </mask>
      <path
        d="M24 36C24 29.3726 29.3726 24 36 24H312C318.627 24 324 29.3726 324 36V230H24V36Z"
        fill="white"
      />
      <path
        d="M22 36C22 28.268 28.268 22 36 22H312C319.732 22 326 28.268 326 36H322C322 30.4772 317.523 26 312 26H36C30.4772 26 26 30.4772 26 36H22ZM324 230H24H324ZM22 230V36C22 28.268 28.268 22 36 22V26C30.4772 26 26 30.4772 26 36V230H22ZM312 22C319.732 22 326 28.268 326 36V230H322V36C322 30.4772 317.523 26 312 26V22Z"
        fill="#D5D7DA"
        mask={`url(#${innerMaskId})`}
      />
      <path
        d="M72.9785 50.1104V41.9824H72.8623L70.4082 43.7187V42.0576L72.9854 40.2461H74.7422V50.1104H72.9785Z"
        fill="#E9EAEB"
      />
      <path
        d="M66.377 50.1104V48.2168H61.5508V46.7744C62.8291 44.5527 64.2305 42.2832 65.5703 40.2461H68.0654V46.7607H69.3916V48.2168H68.0654V50.1104H66.377ZM63.1914 46.8018H66.4043V41.6543H66.3018C65.29 43.1992 64.1484 45.0244 63.1914 46.6992V46.8018Z"
        fill="#E9EAEB"
      />
      <path
        d="M58.9893 43.7188C58.3672 43.7188 57.9023 43.2402 57.9023 42.6387C57.9023 42.0303 58.3672 41.5586 58.9893 41.5586C59.6182 41.5586 60.0762 42.0303 60.0762 42.6387C60.0762 43.2402 59.6182 43.7188 58.9893 43.7188ZM58.9893 48.791C58.3672 48.791 57.9023 48.3193 57.9023 47.7109C57.9023 47.1025 58.3672 46.6309 58.9893 46.6309C59.6182 46.6309 60.0762 47.1025 60.0762 47.7109C60.0762 48.3193 59.6182 48.791 58.9893 48.791Z"
        fill="#E9EAEB"
      />
      <path
        d="M52.4473 40C54.5527 40 56.3848 41.4971 56.3848 45.0518V45.0654C56.3848 48.3877 54.8877 50.3564 52.4062 50.3564C50.5947 50.3564 49.2412 49.2832 48.9268 47.7725L48.9131 47.6973H50.6494L50.6699 47.7656C50.9297 48.4561 51.5381 48.9072 52.4062 48.9072C53.9717 48.9072 54.6348 47.376 54.71 45.4893C54.71 45.4141 54.7168 45.3389 54.7168 45.2637H54.5801C54.2178 46.043 53.3564 46.7334 52.0029 46.7334C50.1094 46.7334 48.7832 45.3525 48.7832 43.4795V43.4658C48.7832 41.4629 50.3076 40 52.4473 40ZM52.4404 45.3799C53.5547 45.3799 54.4092 44.5732 54.4092 43.459V43.4453C54.4092 42.3174 53.5547 41.4355 52.4609 41.4355C51.374 41.4355 50.5059 42.3037 50.5059 43.4043V43.418C50.5059 44.5596 51.3193 45.3799 52.4404 45.3799Z"
        fill="#E9EAEB"
      />
      <path
        d="M43.7529 50.3564C41.4082 50.3564 40 48.3672 40 45.1816V45.168C40 41.9824 41.4082 40 43.7529 40C46.0977 40 47.5195 41.9824 47.5195 45.168V45.1816C47.5195 48.3672 46.0977 50.3564 43.7529 50.3564ZM43.7529 48.9277C45.0107 48.9277 45.7422 47.5195 45.7422 45.1816V45.168C45.7422 42.8301 45.0107 41.4355 43.7529 41.4355C42.4951 41.4355 41.7773 42.8301 41.7773 45.168V45.1816C41.7773 47.5195 42.4951 48.9277 43.7529 48.9277Z"
        fill="#E9EAEB"
      />
      <path
        d="M236.104 40.4375C236.843 40.4375 237.443 41.0149 237.443 41.7275V49.9014C237.443 50.6141 236.844 51.1924 236.104 51.1924H234.764C234.024 51.1924 233.424 50.6141 233.424 49.9014V41.7275C233.424 41.0149 234.024 40.4375 234.764 40.4375H236.104ZM223.492 46.0293C224.232 46.0293 224.832 46.6076 224.832 47.3203V49.9014C224.832 50.614 224.232 51.1914 223.492 51.1914H222.152C221.412 51.1914 220.813 50.614 220.812 49.9014V47.3203C220.812 46.6076 221.412 46.0293 222.152 46.0293H223.492ZM229.798 43.4482C230.538 43.4482 231.138 44.0265 231.138 44.7393V49.9014C231.138 50.614 230.538 51.1914 229.798 51.1914H228.458C227.718 51.1914 227.118 50.614 227.118 49.9014V44.7393C227.118 44.0265 227.718 43.4482 228.458 43.4482H229.798ZM242.409 37.4258C243.149 37.4258 243.749 38.0041 243.749 38.7168V49.9014C243.749 50.614 243.149 51.1913 242.409 51.1914H241.069C240.329 51.1914 239.73 50.6141 239.729 49.9014V38.7168C239.729 38.004 240.329 37.4258 241.069 37.4258H242.409Z"
        fill="#E9EAEB"
      />
      <path
        d="M257.577 48.123C259.208 46.7126 261.596 46.7125 263.227 48.123C263.309 48.1989 263.356 48.3068 263.358 48.4199C263.361 48.5329 263.317 48.6415 263.238 48.7207L260.685 51.3564C260.61 51.4339 260.508 51.4775 260.401 51.4775C260.295 51.4775 260.193 51.4339 260.118 51.3564L257.564 48.7207C257.486 48.6415 257.442 48.5328 257.444 48.4199C257.447 48.3068 257.495 48.1989 257.577 48.123ZM254.169 44.6064C257.682 41.2637 263.123 41.2638 266.637 44.6064C266.716 44.6847 266.761 44.7926 266.763 44.9053C266.764 45.0181 266.72 45.127 266.643 45.207L265.167 46.7324C265.015 46.8882 264.768 46.8919 264.612 46.7402C263.459 45.6717 261.958 45.08 260.401 45.0801C258.846 45.0808 257.346 45.6723 256.193 46.7402C256.037 46.8918 255.792 46.8882 255.64 46.7324L254.164 45.207C254.086 45.1272 254.043 45.0189 254.044 44.9062C254.045 44.7934 254.09 44.6848 254.169 44.6064ZM250.762 41.1006C256.15 35.8181 264.652 35.8181 270.041 41.1006C270.119 41.179 270.162 41.2858 270.163 41.3975C270.164 41.5093 270.121 41.6169 270.044 41.6963L268.566 43.2217C268.414 43.3782 268.166 43.3807 268.012 43.2266C265.959 41.2301 263.234 40.1163 260.401 40.1162C257.568 40.1163 254.843 41.2299 252.79 43.2266C252.636 43.3808 252.388 43.3784 252.236 43.2217L250.758 41.6963C250.681 41.6168 250.638 41.5093 250.639 41.3975C250.639 41.2857 250.684 41.179 250.762 41.1006Z"
        fill="#E9EAEB"
      />
      <g clipPath={`url(#${batteryClipId})`}>
        <rect
          opacity="0.4"
          x="277.555"
          y="38.5"
          width="27.7129"
          height="13.9132"
          rx="3.5"
          stroke="#E9EAEB"
        />
        <path
          opacity="0.5"
          d="M306.916 43.1621V47.7508C307.842 47.3622 308.444 46.4581 308.444 45.4564C308.444 44.4548 307.842 43.5507 306.916 43.1621Z"
          fill="#E9EAEB"
        />
        <rect
          x="279.352"
          y="40.2949"
          width="24.1188"
          height="10.3245"
          rx="2"
          fill="#E9EAEB"
        />
      </g>
      <ellipse cx="52" cy="86" rx="12" ry="12" fill="#E9EAEB" />
      <image
        x="109"
        y="74"
        width="130"
        height="24"
        preserveAspectRatio="xMidYMid meet"
        xlinkHref={props.src ?? undefined}
      />
      <path
        d="M304 80L292 92M292 80L304 92"
        stroke="#E9EAEB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <foreignObject x="40" y="110" width="268" height="44">
        <p
          className="line-clamp-2 text-base leading-tight font-semibold"
          style={{ color: "#181D27" }}
        >
          {props.title}
        </p>
      </foreignObject>
      <rect x="40" y="158" width="266" height="23" rx="3" fill="#E9EAEB" />
      <rect x="40" y="193" width="220" height="23" rx="3" fill="#E9EAEB" />
      <defs>
        <clipPath id={batteryClipId}>
          <rect
            width="31.3889"
            height="14.9132"
            fill="white"
            transform="translate(277.055 38)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
